export type AssigneeEmployee = {
    id: number;
    user_id?: number | null;
};

export function getEmployeeUserIds(employees: AssigneeEmployee[] = []): Set<number> {
    return new Set(
        employees.map((employee) => employee.user_id).filter((id): id is number => id != null),
    );
}

export function filterUserIdsWithoutEmployees(
    userIds: number[] = [],
    employees: AssigneeEmployee[] = [],
): number[] {
    const employeeUserIds = getEmployeeUserIds(employees);

    return userIds.filter((id) => !employeeUserIds.has(id));
}

export function toAssigneeIds(
    employeeIds: number[] = [],
    userIds: number[] = [],
    employees: AssigneeEmployee[] = [],
): string[] {
    const filteredUserIds = filterUserIdsWithoutEmployees(userIds, employees);

    return [
        ...employeeIds.map((id) => `employee:${id}`),
        ...filteredUserIds.map((id) => `user:${id}`),
    ];
}

export function dedupeAssigneeIds(
    assigneeIds: string[] = [],
    employees: AssigneeEmployee[] = [],
): string[] {
    const userIdToEmployeeId = new Map<number, number>();

    for (const employee of employees) {
        if (employee.user_id != null) {
            userIdToEmployeeId.set(employee.user_id, employee.id);
        }
    }

    const employeeIds = new Set<number>();
    const userIds = new Set<number>();

    for (const assigneeId of assigneeIds) {
        if (assigneeId.startsWith('employee:')) {
            employeeIds.add(Number(assigneeId.slice('employee:'.length)));
        } else if (assigneeId.startsWith('user:')) {
            const userId = Number(assigneeId.slice('user:'.length));
            const employeeId = userIdToEmployeeId.get(userId);

            if (employeeId != null) {
                employeeIds.add(employeeId);
            } else {
                userIds.add(userId);
            }
        }
    }

    return [
        ...Array.from(employeeIds).map((id) => `employee:${id}`),
        ...Array.from(userIds).map((id) => `user:${id}`),
    ];
}

export function splitAssigneeIds(assigneeIds: string[] = []): {
    employee_ids: number[];
    user_ids: number[];
} {
    const employee_ids: number[] = [];
    const user_ids: number[] = [];

    for (const assigneeId of assigneeIds) {
        if (assigneeId.startsWith('employee:')) {
            employee_ids.push(Number(assigneeId.slice('employee:'.length)));
        } else if (assigneeId.startsWith('user:')) {
            user_ids.push(Number(assigneeId.slice('user:'.length)));
        }
    }

    return { employee_ids, user_ids };
}
